import { request } from '@/common';
import { EE, HelperCore } from '@/common/dependencies';
import Loader from '@/common/helper/loader';
import Local from '@/common/helper/local';
import globalStore from '@/store/global';
import userStore from '@/store/user';
import { makeAutoObservable, runInAction } from 'mobx';

const PAGE_SIZE = 50;
const LOCAL_KEY = "NAMI_MULTI_KNOWLEDGE";

class Store {
  sence = "";
  localData = null;
  disabled = false;

  listPersonal = [];    // 个人
  listCreated = [];     // 自建
  listShared = [];      // 别人分享

  pageCreated = 1;
  pageShared = 1;
  totalCreated = 0;
  totalShared = 0;
  hasMoreCreated = false;
  hasMoreShared = false;
  isLoading = false;

  listSelected = [];    // 选择的知识库 ID 列表
  selectAll = false;    // 是否全选

  get selectAllStatus () {
    if(this.selectAll){
      return "all";
    }
    if(
      this.listSelected.length
      && this.listSelected.length == this.listPersonal.length + this.listCreated.length + this.listShared.length
      && !this.hasMore
    ){
      return "all";
    }
    if(this.listSelected.length){
      return "some";
    }
    return "none";
  }

  // 显示当前选中的数量
  get total () {
    if(!this.selectAll){
      return this.listSelected.length;
    }
    return this.totalCreated + this.totalShared;
  }
  // 知识库总数
  get totalCount () {
    return this.totalCreated + this.totalShared;
  }

  get hasMore () {
    return this.hasMoreCreated || this.hasMoreShared;
  }

  constructor () {
    makeAutoObservable(this);
    this.getLocalData();
    EE.on("loginStatusUpdate", this.removeLocalData);
  }

  init = (sence, forceUpdate) => {
    this.sence = sence;
    if(!this.sence){
      return;
    }

    // 已设置过(会话页，由历史消息决定)
    if(this.listSelected.length && !forceUpdate){
      this.checkActiveKnowledge();
      return;
    }

    const status = globalStore.cloudConfig?.assistantChatKnSelectMode?.[sence];

    if (status === undefined) {
      return
    }

    // 云控 & 用户操作
    const localData = this.localData?.[this.sence];

    if(localData){
      this.selectAll = localData.selectAll;
      this.listSelected = localData.listSelected;
    }
    else if(status == 1){
      this.selectAll = true;
      this.setSelectedAll();
    }
    else if(status == 2){
      this.selectAll = false;
      this.listSelected = [];
    }
    else if(status == 3){
      this.selectAll = false;
      if(this.listPersonal.length){
        this.listSelected = [this.listPersonal[0].folder_id];
      }
    }
    this.checkActiveKnowledge();
  }
  getLocalData () {
    this.localData = Local.getItem(LOCAL_KEY);
  }
  saveLocalData () {
    const localData = HelperCore.copyObj(this.localData || {});
    localData[this.sence] = HelperCore.copyObj({
      selectAll : this.selectAll,
      listSelected : this.listSelected,
    });
    if(!this.sence){
      return;
    }
    this.localData = localData;
    Local.setItem(LOCAL_KEY, localData);
  }
  removeLocalData = () => {
    Local.removeItem(LOCAL_KEY);
  }

  checkActiveKnowledge () {
    if(!this.listSelected.length){
      return;
    }

    const allList = [
      ...this.listPersonal,
      ...this.listCreated,
      ...this.listShared,
    ];
    const allIds = allList.map(item => item.folder_id);
    this.listSelected = this.listSelected.filter(folder_id => allIds.includes(folder_id));
  }

  loadData = async () => {
    if(!userStore.isUser){
      return;
    }

    await this.loadList(0);
    await this.loadList(1);
  }

  loadMore = async () => {
    if(!this.hasMore){
      return;
    }

    if(this.hasMoreCreated){
      await this.loadList(0);
    }
    else if(this.hasMoreShared){
      await this.loadList(1);
    }
  }

  /**
   * 加载知识库列表
   */
  loadList = async type => {
    const isShare = type == 1;
    return request.get('/knowledge/list', {
      params: {
        need_check_empty : 1,
        // 是否需要分页，默认不分页，返回全部
        // need_page : 1,
        page: isShare ? this.pageShared : this.pageCreated,
        size: PAGE_SIZE,
        type, // 0:我创建的 1:我加入的
      },
    })
    .then(res => {
      runInAction(() => {
        let listData = (res.data?.list || []).map(item => {
          const fixedItem = {
            ...item,
            ...{
              name: Loader.getFixedKnowledgeName(item.name),
            },
          }

          if(item.is_default == 1){
            this.listPersonal = [fixedItem];
            return null;
          }

          return fixedItem;
        })
        .filter(_ => _);
        if (isShare) {
          this.listShared = [...this.listShared, ...listData];
          this.totalShared = res.data.total;
          this.hasMoreShared = this.listShared.length < res.data.total;
        }
        else {
          this.listCreated = [...this.listCreated, ...listData];
          this.totalCreated = res.data.total;
          this.hasMoreCreated = this.listCreated.length + this.listPersonal.length < res.data.total;
        }
      });
    })
    .catch(res => {});
  };

  isSelected (folder_id) {
    return this.selectAll || this.listSelected.includes(folder_id);
  }

  toggleKnowledge (folder_id) {
    HelperCore.log(`toggleKnowledge`, folder_id);

    if(!folder_id){
      if(this.selectAllStatus != "none"){
        this.selectAll = false;
        this.listSelected = [];
      }
      else {
        this.selectAll = true;
        this.setSelectedAll();
      }
      this.saveLocalData();
      return;
    }

    const isChecked = this.selectAll || this.listSelected.includes(folder_id);
    if(isChecked){
      if(this.selectAll){
        this.selectAll = false;
        this.setSelectedAll(folder_id)
      }
      else {
        this.listSelected = this.listSelected.filter(id => id != folder_id);
      }
    }
    else {
      this.listSelected.push(folder_id);
      if(this.selectAllStatus == "all"){
        this.selectAll = true;
      }
    }
    this.saveLocalData();
  }
  setListSelected = (listSelected) => {
    if(listSelected?.length && listSelected.some(id => id == "select_all")){
      this.selectAll = true;
      this.setSelectedAll();
      return;
    }

    this.listSelected = listSelected;
  }

  setSelectedAll = (exclude_id) => {
    this.listSelected = [
      ...this.listPersonal.map(item => item.folder_id),
      ...this.listCreated.map(item => item.folder_id),
      ...this.listShared.map(item => item.folder_id),
    ].filter(id => id != exclude_id);
  }

  getOutput () {
    if(!this.listSelected.length){
      return null;
    }
    if(this.disabled){
      return null;
    }
    const allList = [
      ...this.listPersonal,
      ...this.listCreated,
      ...this.listShared,
    ];

    const output = {};
    this.listSelected.forEach(folder_id => {
      const item = allList.find(_ => _.folder_id == folder_id);
      if(item){
        output[folder_id] = {
          selectAll : this.selectAll,
          ...item,
        };
      }
    });
    return output;
  }

  reloadData = async () => {
    this.reset();
    await this.loadData();
  }

  setDisabled (disabled) {
    this.disabled = disabled;
  }

  clear () {
    // debug
    HelperCore.log(`mutilKnowledgeStore clear`);

    this.selectAll = false;
    this.listSelected = [];
  }

  reset = () => {
    this.listPersonal = [];
    this.listCreated = [];
    this.listShared = [];
    this.pageCreated = 1;
    this.pageShared = 1;
    this.totalCreated = 0;
    this.totalShared = 0;
    this.hasMoreCreated = false;
    this.hasMoreShared = false;
    this.isLoading = false;
    this.disabled = false;
  }
}

const mutilKnowledgeStore = new Store();
export default mutilKnowledgeStore;
